<script lang="ts">
  import factryLogo from '../assets/factry-logo-white.png'
  import idooLogo from '../assets/idoo-logo.png'
</script>

<style lang="scss">
  @import '../utils/base';

  header {
    align-items: center;
    background-color: $white-ter;
    border-bottom: 1px solid $border;
    display: flex;
    padding: $spacing * 0.5;
    position: sticky;
    top: 0;
    z-index: 10;

    @media (max-width: 1000px) {
      padding: $spacing * 0.25;
    }
  }

  .logo--factry {
    background-color: $factry-color;
    border-radius: $radius;
    flex-shrink: 0;
    height: 64px;
    margin-right: $spacing * 0.5;
    padding: $spacing * 0.125;

    @media (max-width: 1000px) {
      height: 48px;
    }
  }

  .is-text {
    font-size: $size-large;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .logo--idoo {
    flex-shrink: 0;
    height: 48px;
    margin-left: auto;
    padding: $spacing * 0.25;

    @media (max-width: 1000px) {
      height: 36px;
    }
  }
</style>

<header>
  <img src={factryLogo} alt="Factry" class="logo--factry" />
  <div class="is-text">Pipe Passport</div>
  <img src={idooLogo} alt="iDOO" class="logo--idoo" />
</header>
